import { Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';

import {
  DidGroupReportFilter,
  DidGroupReportTable,
} from '@components/Reports/DidGroup';
import '@components/Reports/DidGroup/DidGroupReportFilter';
import { Page404 } from '@containers/ErrorPages';
import { reportsApi } from '@reducers/reports/reports';

export const DidGroup = () => {
  const { isCapacity } = useSelector((state) => state.auth.user);
  if (!isCapacity) {
    return <Page404 />;
  }
  return (
    <Row>
      <Col md={3}>
        <DidGroupReportFilter />
      </Col>
      <Col md={9}>
        <DidGroupReportTable useData={reportsApi.useGetDidGroupsReportQuery} />
      </Col>
    </Row>
  );
};
